import { useSearchParamsContext } from '@internal/blocks/SearchResultsBlock/SearchParamsContext'
import { MachineType } from '@internal/utils/machine/MachineType'
import { localeNamespace } from '@internal/utils/machine/i18n/Locale'
import { MachineTypeSelectFilter } from '@renderer-ui-library/molecules'
import { useSearchResultsRouting } from 'blocks/SearchResultsBlock/useSearchResultsRouting'
import { translations } from 'i18n/translations'
import { useTranslation } from 'next-i18next'
import React, { useCallback } from 'react'
import { tracker } from 'utils/tracking/tracker'
import { SearchFilterCategory } from './SearchFilterCategory/SearchFilterCategory'

export const MachineTypeFilter: React.FC = React.memo(() => {
  const { searchParams } = useSearchParamsContext()
  const { gotoSearchResults } = useSearchResultsRouting()
  const { t } = useTranslation(localeNamespace.common)

  const handleMachineTypeChange = useCallback(
    (machineType: MachineType | null) => {
      gotoSearchResults({
        ...searchParams,
        machineType: machineType ?? undefined,
        amount: undefined,
      })
      tracker.trackEvent({
        name: 'filter-applied',
        filter_placement: 'serp',
        filter_category: 'machine-type',
        filter_machine_type: machineType ?? 'any',
        is_interaction: true,
      })
    },
    [gotoSearchResults, searchParams]
  )

  return (
    <SearchFilterCategory
      title={t(translations.searchResultsFiltersMachineTypeLabel)}
    >
      <MachineTypeSelectFilter
        selectedMachineType={searchParams.machineType ?? null}
        onChange={handleMachineTypeChange}
      />
    </SearchFilterCategory>
  )
})

MachineTypeFilter.displayName = 'MachineTypeFilter'
